export class LandingPageConstants {
    static LOGIN_TEXT = "Login";
}
